import { UPDATE_LOADING_PERCENT } from '../constants/actionTypes'

export default (state = 0, action) => {
    switch (action.type) {
        case UPDATE_LOADING_PERCENT:
            return action.payload
        default:
            return state
    }
}
